import {
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface DrawerProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title?: string;
  maxWidth?: string;
  children: React.ReactNode;
}

const Drawer: React.FC<DrawerProps> = ({
  open,
  setOpen,
  title,
  maxWidth = "max-w-md",
  children,
}) => {
  return (
    <Dialog open={open} onClose={setOpen} className="relative z-40">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
            <DialogPanel
              className={`pointer-events-auto w-screen bg-white shadow-xl p-6 overflow-y-auto ${maxWidth}`}
            >
              <div className="flex justify-between items-center mb-4">
                {title && (
                  <DialogTitle className="text-lg font-medium text-gray-900">
                    {title}
                  </DialogTitle>
                )}
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <XMarkIcon className="h-6 w-6" />
                </button>
              </div>
              {children}
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default Drawer;
